import React, { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import { RideGrid, RideButton } from "@rimac-seguros/ride-system-components";

import { useLeadsService } from "@/services/leads.service";
import { usePersonService } from "@/services/person.service";
import { usePaymentService } from "@/services/payment.service";
import { saveLeadData } from "@/redux/actions/vida";
import { showModalLoading } from "@/redux/actions/global";
import { showModalAddBeneficiaries } from "@/redux/actions/beneficiaries";
import history from "@/utils/history";
import { configVisaDecode } from "@/utils/awsConfig";
import {
  planSelected as planSelectedAction,
  selectQuote,
} from "@/redux/actions/plans";
import helpers from "@/utils/helpers";
import { getProductOptions } from '@/utils/product'
import { useQuoteService } from '@/services/quote.service'

export const FooterAction = ({
  disabled,
  nextStep,
  stepFinish,
  isVidaPlus,
}) => {
  const { digitalDataProductName } = getProductOptions();
  const isVE = helpers.validateVidaEndosable();
  const { productName } = getProductOptions();
  const { planSelected, addThirdSuccess, typeOfFinancing } = useSelector(
    (state) => state.plans
  );
  const { userData, leadData } = useSelector((state) => state.vida);
  const domicilio = useSelector((state) => state.domicilio);
  const { session } = useSelector((state) => state.token);
  const { beneficiaries } = useSelector((state) => state.beneficiaries);
  const { relationshipList } = useSelector((state) => state.global);

  const { sendLeads } = useLeadsService();
  const { addThirdToQuote } = usePersonService();
  const { getToken } = usePaymentService();
  const { endorseQuoteVE } = useQuoteService();

  const dispatch = useDispatch();

  useEffect(() => {
    if (addThirdSuccess && session) {
      dispatch(showModalLoading(""));
      dispatch(showModalAddBeneficiaries(false));
      history.push(nextStep);
    }
  }, [addThirdSuccess, session]);

  const sendBeneficiariesDistribution = () => {
    const list = beneficiaries.map((beneficiary) => {
      const relationship = relationshipList.find(
        (_) => _.id === Number(beneficiary?.relationship)
      )?.descripcion;
      return `${relationship}|${beneficiary.percentage}%`;
    });

    helpers.getTagMetadata(
      isVidaPlus
        ? "Seguro Vida Plus - Distribución beneficiarios"
        : `Distribución beneficiarios ${digitalDataProductName}`,
      `${beneficiaries.length} - ${list.join(" - ")}`,
      "trackMetadata"
    );
  }

  const handleClickContinue = async () => {
    dispatch(showModalLoading("No olvides tener tu tarjeta de pago a la mano"));
    helpers.getTagVirtual(`sol:${productName}:loader-pago`);

    try {
      const leadToSend = {
        ...leadData,
        finalizado: stepFinish,
      };

      await dispatch(saveLeadData(leadToSend));
      await sendLeads(leadToSend);

      if (!isVE) {
        if (isVidaPlus) {
          await selectedPlanToService();
        }

        await addThird();
      } else {
        await endorseQuoteVE({
          userData,
          domicilioData: domicilio
        });

        sendBeneficiariesDistribution();
      }
      await getPaymentToken();
    } catch (error) {
      console.error("Error", error);
    }
  };

  const getPaymentToken = async () => {
    try {
      const payloadToken = {
        producto: "VCT",
        ideCotizacion: isVE ? planSelected?.idCotizacion : planSelected.ideTransaccion,
        correo: userData.email,
        idePlan: String(isVE ? planSelected?.planId : planSelected.plan.idePlan),
      };
      await getToken(payloadToken);
    } catch (error) {
      console.error("Error getPaymentToken", error);
    }
  };

  const addThird = async () => {
    try {
      await addThirdToQuote(
        userData,
        {
          ...userData.userAddress,
          numeroVia: userData.userAddress.numeroVia || "SN",
        },
        planSelected
      );

      sendBeneficiariesDistribution();
    } catch (error) {
      console.error("Error addThird", error);
    }
  };

  const selectedPlanToService = async () => {
    const request = {
      ideTransaccion: planSelected.ideTransaccion,
      idePlan: planSelected.plan.idePlan,
      ideFinanciamiento: typeOfFinancing.ideFinanciamiento,
      idePlanFinanciamiento: typeOfFinancing.idePlanFinanciamiento,
      clienteAplicacion: configVisaDecode[1].value,
    };
    const response = await dispatch(selectQuote(request));
    await dispatch(
      planSelectedAction({
        ...planSelected,
        idSolicitud: response.payload.idSolicitud,
      })
    );
  };

  return (
    <div className="fixed bottom-0 left-0 z-10 w-full py-ride-gl-spacing-2xlarge bg-ride-sys-color-background-default shadow-ride-gl-shadow-moderate lg:py-ride-gl-spacing-3xlarge">
      <RideGrid>
        <div className="flex justify-center col-span-full lg:justify-end">
          <RideButton
            text="Continuar"
            size="x-large"
            onClick={handleClickContinue}
            disabled={disabled}
            className="w-full md:w-auto"
          />
        </div>
      </RideGrid>
    </div>
  );
};
